import { render, staticRenderFns } from "./ProductAttrDetail.vue?vue&type=template&id=5a896937&scoped=true&"
import script from "./ProductAttrDetail.vue?vue&type=script&lang=js&"
export * from "./ProductAttrDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a896937",
  null
  
)

export default component.exports